import { DatePickerMobileSelectorColumnCellProps } from './props';

/**
 * Helper function to format date picker option labels based on type (day, month, year)
 *
 * @template T - Generic type for the value parameter
 * @param {Object} params - Parameters object
 * @param {('day'|'month'|'year')} params.type - Type of date value to format
 * @param {T} value - The value to format into a label
 * @returns {string|number} Formatted label:
 * - For days: Returns numeric value
 * - For months: Returns translation key in format "month_X"
 * - For years: Returns value as-is
 */
export function getDatePickerOptionLabel<T>(
  { type }: Pick<DatePickerMobileSelectorColumnCellProps<T>, 'type'>,
  value: T,
) {
  switch (type) {
    case 'day':
      return Number(value);
    case 'month':
      return `month_${value}`;
    case 'year':
      return value;
  }
}
